import { render } from "./VideoListComponent.vue?vue&type=template&id=78d019ee"
import script from "./VideoListComponent.vue?vue&type=script&lang=js"
export * from "./VideoListComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__